<template>
  <card class="wrapper-store">
    <div class="store-detail">
      <el-image
        style="
          width: 100px;
          border-radius: 8px;
          height: 100px;
          margin-right: 20px;
        "
        :src="detailInfo.store ? detailInfo.store.coverImageUrl : ''"
        :preview-src-list="[
          detailInfo.store ? detailInfo.store.coverImageUrl : '',
        ]"
      >
        <div
          style="
            background: #f5f7fa;
            width: 100px;
            height: 100px;
            line-height: 100px;
            text-align: center;
            color: #c0c4cc;
          "
          slot="error"
        >
          暂无图片
        </div>
      </el-image>

      <div class="store-detail-right">
        <div class="store-title">
          <span class="fw700">{{ detailInfo.store ? detailInfo.store.storeName : "" }}</span>
          <div
            class="store-tag"
            v-if="
              detailInfo.store &&
              detailInfo.store.storeTagList &&
              detailInfo.store.storeTagList.length > 0
            "
          >
            <el-tag
              v-for="(item, i) in detailInfo.store.storeTagList"
              :key="i"
              type="primary"
              effect="plain"
            >
              {{ item }}
            </el-tag>
          </div>
        </div>

        <div class="store-desc">
          <div>
            <span class="label">等级：</span>
            <span class="value">{{ detailInfo.store.storeGrade ? `${detailInfo.store.storeGrade}级` : "-" }}</span>
          </div>
          <div>
            <span class="label">BD：</span>
            <span class="value">{{ detailInfo.store ? detailInfo.store.businessUserName : "" }}</span>
          </div>
          <div>
            <span class="label">建店时间：</span>
            <span class="value">{{ detailInfo.store ? detailInfo.store.createDate : "" }}</span>
          </div>
        </div>

        <div class="store-stat">
          <el-row :gutter="20">
            <el-col :span="4">
              <span class="label">申请量：</span>
              <span class="value">{{ detailInfo.store ? detailInfo.store.applyOrderNum : "" }}</span>
            </el-col>
            <el-col :span="4">
              <span class="label">成单量：</span>
              <span class="value">{{ detailInfo.store ? detailInfo.store.dealOrderNum : "" }}</span>
            </el-col>
            <el-col :span="4">
              <span class="label">在租量：</span>
              <span class="value">{{ detailInfo.store ? detailInfo.store.rentOrderNum : "" }}</span>
            </el-col>
            <el-col :span="4">
              <span class="label">在逾量：</span>
              <span class="value">{{ detailInfo.store ? detailInfo.store.overdueOrderNum : "" }}</span>
            </el-col>
            <el-col :span="4">
              <span class="label">结单量：</span>
              <span class="value">{{ detailInfo.store ? detailInfo.store.fullPayOrderNum : "" }}</span>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="8">
              <span class="label">订单逾期率：</span>
              <span class="value">{{ detailInfo.store ? detailInfo.store.overdueOrderRate : "" }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">订单取消率：</span>
              <span class="value">{{ detailInfo.store ? detailInfo.store.cancelOrderRate : "" }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">设备离线率：</span>
              <span class="value">{{ detailInfo.store ? detailInfo.store.offlineRate : "" }}</span>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";

export default {
  name: "storeInformation",
  mixins: [authBtnMixin],
  inject: ["reload"],

  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },

    flag: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper-store ::v-deep {
  border-color: transparent;
  margin-top: 20px;
  width: 100%;
  border-radius: 16px;
  color: #222222;

  .para-title {
    font-size: 20px;
    font-weight: bold;
    padding: 5px 0;
  }

  .store-detail {
    display: flex;
    margin-top: 5px;

    .store-detail-right {
      display: flex;
      flex-direction: column;
      width: 100%;

      .store-title {
        color: #333333;
        font-size: 18px;
        display: flex;
        flex-direction: row;
      }

      .store-tag {
        margin-left: 10px;
        gap: 5px;
      }

      .store-desc {
        font-size: 13px;
        line-height: 15px;
        display: flex;
        flex-direction: row;
        gap: 20px;
        margin: 10px 0;

        .value {
          font-weight: bold;
        }
      }

      .store-stat {
        background: #f7f8fa;
        color: #222222;
        border-radius: 16px;
        position: relative;
        padding: 15px;
        line-height: 30px;

        .value {
          display: inline-block;
          font-weight: 700;
        }

        .label {
          text-align: right;
          display: inline-block;
        }
      }
    }
  }

  .el-tag {
    height: 25px;
    border-radius: 15px;
    margin-right: 10px;
    line-height: 25px;
  }
}

.fw700 {
  font-weight: 700;
}
</style>
